import { useQuery } from '@tanstack/react-query';
import { getFeatureFlags } from '../Redux/util/Apis/featureFlags';

export const useFeatureFlags = (tenantId = null) => {
  return useQuery({
    queryKey: ['featureFlags', tenantId],
    queryFn: async () => {
      const response = await getFeatureFlags(tenantId);
      return response?.data || {};
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000
  });
};

export default useFeatureFlags;
